"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Page = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../../../../hooks");
var _Context = require("./Context");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Page = function Page(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_Context.Context.Provider, {
    value: (0, _hooks.useSendPage)()
  }, children);
};
exports.Page = Page;